import { Injectable, inject } from "@angular/core";
import { ApiClientService } from "~app/common/services/api-client.service";
import { CertifikatDto, CertifikatKontraktDto, CertifikatSearchFilterDto } from "./certifikat-models";

@Injectable({
    providedIn: "root"
})
export class CertifikatService {
    private readonly api = inject(ApiClientService);

    getCertifikat(filter: CertifikatSearchFilterDto) {
        return this.api.get<CertifikatDto[]>("certifikat", false, filter);
    }

    getRelateradeKontrakt(id: number) {
        return this.api.get<CertifikatKontraktDto[]>(`certifikat/${id}/getRelateradeKontrakt`);
    }

    saveCertifikat(certifikat: CertifikatDto) {
        return this.api.post("certifikat/save", certifikat);
    }

    deleteCertifikat(id: number) {
        return this.api.post(`certifikat/${id}/delete`, null);
    }

    createCertifikat(certifikat: CertifikatDto) {
        return this.api.post("certifikat/create", certifikat);
    }
}
